import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import DefaultUserGroupAction from "app/components/Base/DefaultUserGroup/DefaultUserGroupAction"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class DefaultUserGroupActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Base/DefaultUserGroup/DefaultUserGroupForm")
	}

	render() {
		return (
			<Activity 
				name="defaultUserGroup"
				RenderedComponent={this.RenderedComponent}
                context=""
                formActions={DefaultUserGroupAction}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(DefaultUserGroupActivity)
